import { DreamBlock, TextLeaf } from '@typedream/core';
import { getNode } from '@udecode/plate-core';
import classNames from 'classnames';
import { memo } from 'react';
import shallow from 'zustand/shallow';
import { Dropdown, DropdownItem } from '../../../components/Dropdown';
import { useTPlateEditorRef } from '../../../plate';
import { useDreamEditorStore } from '../../../plugins/store';
import { DEFAULT_TEXT_STYLE } from '../../../nodes/text/defaults';
import { fontStyles } from '../../../nodes/text/fonts';
import { setFontStyle } from '../../../nodes/text/transforms';
import styles from '../SideToolbar.module.css';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { BaseDreamEditor } from '../../../types';
import { ELEMENT_BLOCKQUOTE, ELEMENT_PARAGRAPH } from '../../../pluginKeys';

function TextStyle() {
  const editor = useTPlateEditorRef();

  const [currentFontStyle, isDisabled] = useDreamEditorStore((state) => {
    let fontStyle = DEFAULT_TEXT_STYLE;
    const selectedElement = getSelectedElementEntry(
      state.editor as BaseDreamEditor,
    )?.[0] as DreamBlock;
    if (state.editor?.selection) {
      const el = getNode<TextLeaf>(editor, state.editor.selection.focus.path);
      if (el?.fontStyle) {
        fontStyle = el.fontStyle;
      }
    }

    const textStyleDisabled = !state.editor?.selection
      || ![ELEMENT_PARAGRAPH, ELEMENT_BLOCKQUOTE].includes(selectedElement.type);
    return [fontStyle, textStyleDisabled];
  }, shallow);

  return (
    <div className={styles.section}>
      <span className={styles.label}>Text Style</span>
      <Dropdown
        triggerLabel={(
          <div>
            {fontStyles[currentFontStyle as keyof typeof fontStyles].title}
          </div>
        )}
        disabled={isDisabled}
      >
        {Object.entries(fontStyles).map(([k, v]) => (
          <DropdownItem key={k}>
            <div
              role="none"
              onClick={() => setFontStyle(editor, k as keyof typeof fontStyles)}
              style={v.styles}
              className={classNames(styles.cursorPointer, 'with-text-color')}
            >
              {v.title}
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
}

export default memo(TextStyle);
